import { DropdownButton } from "@biteship/atom";
import { useState, useEffect, useMemo } from "react";
import { getCouriers } from "../../../store/action/courier";

export default function CourierCode({
  onSelect,
}) {
  const [buttonTitle, setButtonTitle] = useState("Pilih Nama Kurir");
  const [options, setOptions] = useState([]);
  const [courierCode, setCourierCode] = useState("");

  useEffect(() => {
    _fetchData();
  }, []);

  const _fetchData = async () => {
    getCouriers()
      .then(({ couriers }) => {
        const filteredCouriers = couriers.reduce((r, i) => {
          const courierExist = r.some((courier) => courier.value === i.courierCode);
          if (!courierExist)
            r.push({
              value: i.courierCode,
              title: i.courierName,
            });
          return r;
        }, []);
        setOptions(filteredCouriers);
      })
      .catch((err) => {
        alert("Gagal mengambil data kurir");
        console.log(err);
      });
  };

  const dropdownOptions = useMemo(() => {
    const courierOptions = options.map((i) => ({
      title: i.title,
      onClick: (e) => {
        setButtonTitle(i.title);
        onSelect(i.value);
      },
    }));
    courierOptions.push({
      title: "Lainnya",
      onClick: (e) => {
        setButtonTitle("Lainnya");
        onSelect("other");
      },
    });
    return courierOptions;
  }, [options, onSelect]);

  return (
    <DropdownButton
      title={
        <div
          className={`${buttonTitle === "Pilih Nama Kurir" ? "text-gray-700" : "text-gray-900"}`}
        >
          {buttonTitle}
        </div>
      }
      actions={[dropdownOptions]}
      buttonClassName="items-center border-gray-700"
      menuClassName="w-full max-h-56"
      className="w-full"
      search
      searchText={"Cari Kurir"}
    />
  );
}
